import { togglePayrollModal } from "app/static/frontend/global-action-creators"
import { connect } from "react-redux"
import { PayrollFormModal } from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal/PayrollFormModal"

const mapStateToProps = (state) => {
    return state.payrollModal
}

export default connect(mapStateToProps, { togglePayrollModal })(PayrollFormModal)
